import React, { useState, useEffect } from 'react';
import { node_api, producaov2 } from '../../services/apis';
import { Message, Loader, Checkbox } from 'semantic-ui-react';
import swal from 'sweetalert';


function Aprovado(props){
    const [aprovado,setAprovado] = useState(false);
    const [loading,setLoading] = useState(true);
    const {id_curso,id_aluno,id_licao,nome_licao} = props.info;

    useEffect(()=>{
        producaov2.post('/admin/projeto/aprovado',{id_curso,id_aluno})
            .then((v)=>{
                setLoading(false)
                setAprovado(v.data.aprovado)
            })
    },[props.info])

    async function aprovar(action){
        setLoading(true)
        alert('aprovar')
        const data = {id_curso,id_aluno,projeto_final:1,id_licao};
        data.projeto_final_verificado = action?1:0;
        const retorno = await producaov2.put('projetos',data)
        console.log('Aprovar dispare',data.projeto_final_verificado)
        .then((v)=>{
            setAprovado(action)
            setLoading(false)
        })
        .catch((err)=>{
            console.error(err)
            setLoading(false)
            swal("Ocorreu um erro ao atualizar aprovação!","Houve um erro ao salvar os dados do arquivo enviado. Se o erro persistir, nos contate.","error");
            return false;
        }) 
    }

    function render_button_check(){
        return aprovado ?<><span>Retirar aprovação</span>
        <Checkbox checked onClick={(e,f)=>aprovar(f.checked)} toggle /></>
        :<><span>Aprovar:</span>
        <Checkbox checked={false} onClick={(e,f)=>aprovar(f.checked)} toggle /></>
    }
    return (
        <>
        {
        loading?
        <div class="ui segment">
        <p></p>
        <div class="ui active dimmer">
            <div class="ui small loader"></div>
        </div>
        </div>
        :<center>
                {render_button_check()}
            </center>
        }
        </>
    )
}

export default Aprovado;